import { tokens } from "@core/theme/tokens";
import { portalPrimitiveValues as values } from "./portalPrimitiveValues";

// Interruptor de activo/inactivo (components.md:136, admin.jsx:97-107
// `Toggle`). Usado por catálogos, recompensas, beneficios, usuarios y
// perfiles — se agrega acá, en `portal/common`, porque hasta SPEC-216
// (perfiles) ninguna pantalla escrita todavía lo necesitaba: catálogos usa
// un checkbox de "Activo" en su lugar (CatalogEntryForm.tsx), no este
// componente. Valores literales de admin.jsx, no inventados.
export function Toggle({
  on,
  onChange,
  disabled = false,
  ariaLabel,
}: {
  on: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  ariaLabel?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!on)}
      style={{
        width: values.toggle.width,
        height: values.toggle.height,
        borderRadius: values.toggle.radius,
        cursor: disabled ? "not-allowed" : "pointer",
        flex: "none",
        position: "relative",
        padding: 0,
        opacity: disabled ? 0.55 : 1,
        background: on
          ? `linear-gradient(135deg,${tokens.gold.light},${tokens.gold.deep})`
          : "rgba(255,255,255,0.1)",
        border: `1px solid ${on ? tokens.gold.line : tokens.surface.line2}`,
        transition: "background .2s",
      }}
    >
      <span
        style={{
          position: "absolute",
          top: values.toggle.inset,
          left: on
            ? values.toggle.width - values.toggle.thumb - values.toggle.inset
            : values.toggle.inset,
          width: values.toggle.thumb,
          height: values.toggle.thumb,
          borderRadius: "50%",
          background: on ? "#16201B" : tokens.text.secondary,
          transition: "left .2s",
        }}
      />
    </button>
  );
}
